import React from 'react';
import './App.css';
import About from './component/About/About';
import Certificate from './component/Certificates/Certificate';
import Footer from './component/Footer/Footer';
import Home from './component/Home/Home';
import Project from './component/Projects/Project';
import Skill from './component/Skills/Skill';
import NavBar from './component/navbar/NavBar';

function App() {
  return (
    <div className='App'>
      <NavBar />
      <div className='sections'>
        <Home />
        <About />
        <Skill />
        <Project />
        <Certificate />
      </div>
      <Footer />
    </div>
  );
}

export default App;
